module.exports = function() {
  return new Worker(__webpack_public_path__ + "72971b18e5d5e7e5518c.worker.js");
};